module.exports = __webpack_public_path__ + "images/purchase_hero@1x.jpg?d7cb9083";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/purchase_hero@1x.jpg
// module id = 689
// module chunks = 7